import React from "react";
import { Button } from "@/components/ui/button";

export const MOODS = [
  { id: "tender", label: "Tender", color: "#C9755E" },
  { id: "heavy", label: "Heavy", color: "#5C6E7F" },
  { id: "released", label: "Released", color: "#6B7F5C" },
  { id: "unsettled", label: "Unsettled", color: "#7A5A6B" },
  { id: "clear", label: "Clear", color: "#9E7A44" },
  { id: "grieving", label: "Grieving", color: "#8B7355" },
];

export default function MoodPicker({ value, onChange, testIdPrefix = "mood" }) {
  return (
    <div>
      <label className="block font-sans uppercase tracking-[0.2em] text-[0.65rem] text-bone-500 mb-3">
        How does this feel in your body?
      </label>
      <div className="flex flex-wrap gap-2">
        {MOODS.map((m) => {
          const active = value === m.id;
          return (
            <button
              key={m.id}
              type="button"
              data-testid={`${testIdPrefix}-${m.id}`}
              onClick={() => onChange(active ? null : m.id)}
              className={`px-4 py-2 border font-sans text-xs uppercase tracking-[0.18em] transition-colors ${
                active
                  ? "border-terracotta text-bone-100"
                  : "border-obsidian-600 text-bone-400 hover:text-bone-200 hover:border-bone-500"
              }`}
              style={active ? { backgroundColor: m.color + "33" } : {}}
            >
              <span
                className="inline-block h-2 w-2 rounded-full mr-2 align-middle"
                style={{ backgroundColor: m.color }}
              />
              {m.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
